import CONFIG from "./config";
import md5 from "md5";
import xss from 'xss';

export default {
  init: function () {
    // Setzen der mandantId
    const url = new URL(window.location);
    const verwaltung = url.searchParams.get("verwaltung") === "true";
    const callcenter = url.searchParams.get("callcenter") === "true";
    const lightShop = (url.searchParams.get("lightShop") ?? url.searchParams.get("lightshop")) === "true";
    let mandantId = xss(url.searchParams.get("mandant"));
    let token = xss(url.searchParams.get("token"));
    let tanAuth = url.searchParams.get("tanAuth") === "true";
    let hash = CONFIG.HASH_ID;
    if (token && mandantId && mandantId !== "null") {
      mandantId = Number(mandantId);
      const chash = String(md5(hash + "=" + mandantId)).slice(0, 8);
      localStorage.setItem("mandantIdLink", chash);
      sessionStorage.setItem("mandantId", mandantId);
    } else if (mandantId && mandantId !== "null") {
      mandantId = String(mandantId).slice(0, 8);
      let m = 0;
      let chash = null;
      const time = new Date().getTime() + 5000;
      while (chash !== mandantId && chash !== "b08da3c7" && new Date().getTime() < time) {
        chash = String(md5(hash + "=" + m++)).slice(0, 8);
      }
      mandantId = m - 1;
      if (chash === "b08da3c7") {
        chash = "invalidMandant";
        mandantId = -1;
      }

      // mandantIdlink is used to create external links with the mandantId hash
      localStorage.setItem("mandantIdLink", chash);
      sessionStorage.setItem("mandantId", mandantId);
      token = null;
    } else if (
      sessionStorage.getItem("mandantId") !== null &&
      sessionStorage.getItem("mandantId") !== undefined &&
      sessionStorage.getItem("mandantId") !== "undefined" &&
      sessionStorage.getItem("mandantId") !== "null"
    ) {
      mandantId = sessionStorage.getItem("mandantId");
      token = null;
    }
    let timeout = Number(url.searchParams.get("timeout"));
    if (timeout) {
      sessionStorage.setItem("timeout", timeout);
    } else {
      sessionStorage.setItem("timeout", CONFIG.SESSION_TTL);
    }
    return { mandantId, token, verwaltung, tanAuth, callcenter, lightShop};
  }
};
